import { NextPage } from 'next';
import Head from 'next/head';
import Layout from '../react-components/layout';

const About: NextPage = () => (
  <>
    <Head>
      <title>About</title>
    </Head>
    <Layout>
      <h1>About</h1>
      <h2>About FITSOCIETY.COM</h2>
      <p>
        Our mission is to bring your wellness journey under one platform - FITSOCIETY.COM. With over 30 years of
        fitness, sports, modeling and acting I have worked, competed, and collaborated with the top fitness pros,
        trainers, gyms, photographers, nutritionists, models, agents, federations, etc... FITSOCIETY.COM makes that
        connection for its members and businesses. Whether you&rsquo;re seeking a photographer for a sporting event or a
        photographer for your event or simply apparel to look good FITSOCIETY.COM brings the connection to the
        professional or services for you.
      </p>
      <h2>About Tommy Andrades, creator of FITSOCIETY.COM</h2>
      <p>
        In 2011, Tommy competed in 6 fitness competitions winning 3 and placing in another (Musclemania, WBFF and
        Bodybuilding.com Fitbody contest). He was awarded Pro Cards in both World Body Fitness Federation (WBFF) and
        Musclemania in the same year. In addition, finished 3<sup>rd</sup> place for Bodybuilding.com Fitbody
        competition sponsored by Musclefarm. That sparked multiple appearances in fitness magazines, commercials, and
        many advertisements.
      </p>
      <p>
        Tommy also was a standout Athlete in High School and College. While earning All-state honors in High school,
        became a College all American the ultimate honor of being inducted into the College basketball Hall of Fame at
        the University of Minnesota Crookston in 2019.
      </p>
      <p>Tommy continues to personal train, model, act, and coach basketball. Some of his accolades include:</p>
      <ul className='pl-8 list-disc'>
        <li>NASM Certified Personal Trainer</li>
        <li>NASM Certified Nutrition Coach</li>
        <li>
          Bodybuilding.com FIT Body Contest 3<sup>rd</sup> Place (2011)
        </li>
        <li>2x Musclemania Model America Fitness model champion “Great North” and “New England” (2011)</li>
        <li>Pro card Musclemania Model America Fitness model (2011)</li>
        <li>WBFF Eastern US Champion (2011)</li>
        <li>Pro card WBFF (2011)</li>
        <li>WBFF Worlds pro show in Toronto Canada (2011)</li>
        <li>National Fitness Magazine feature “Exercise for Men”</li>
        <li>HALL of Fame for college basketball at University of Minnesota Crookston (2019)</li>
        <li>All American College Basketball Player 1999</li>
        <li>Modeling with various companies including TV, Video, and Print</li>
        <li>
          Acting Role which he appeared on Tyler Perry’s “For Better or Worse” Season 3 where he played the SAG role of
          “Carlos” which aired on TBS and OWN
        </li>
      </ul>
      <style jsx>{`
        p {
          @apply my-3;
          max-width: 60ch;
        }
      `}</style>
    </Layout>
  </>
);

export default About;
